import { render, staticRenderFns } from "./symbol-pair.component.vue?vue&type=template&id=0eade33e&scoped=true"
import script from "./symbol-pair.component.vue?vue&type=script&lang=js"
export * from "./symbol-pair.component.vue?vue&type=script&lang=js"
import style0 from "./symbol-pair.component.vue?vue&type=style&index=0&id=0eade33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eade33e",
  null
  
)

export default component.exports